import {
  Component,
  inject,
  input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { HomepageModule, HomepageModuleType } from '@ui/shared/model';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioSelect } from '@immomio/ui/select';
import { ImmomioFormFieldComponent } from '@immomio/ui/form';
import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  ImmomioModal,
  ImmomioModalBase,
  ImmomioModalHeader
} from '@immomio/ui/modal';
import { FormFieldLabelComponent } from '../../../components/legacy/form/form-field/form-field-label/form-field-label.component';
import { FormFieldComponent } from '../../../components/legacy/form/form-field/form-field.component';
import { AppInputDirective } from '../../../components/legacy/form/controls/input/input.directive';

@Component({
  selector: 'app-homepage-link-modal',
  templateUrl: './homepage-link-modal.component.html',
  styleUrls: ['./homepage-link-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    FormFieldLabelComponent,
    FormFieldComponent,
    AppInputDirective,
    ImmomioButtonComponent,
    ImmomioModal,
    ImmomioModalHeader,
    ImmomioSelect,
    ImmomioFormFieldComponent
  ]
})
export class HomepageModuleModalComponent
  extends ImmomioModalBase<void, HomepageModule>
  implements OnInit
{
  private fb = inject(FormBuilder);
  public link = input<HomepageModule>(undefined);
  public formGroup = this.fb.group({
    id: [],
    name: ['', Validators.required],
    type: [HomepageModuleType.CARD, Validators.required]
  });
  public homepageModuleTypes = [
    {
      value: HomepageModuleType.CARD,
      name: 'homepage_module.portal_type_tiles'
    },
    {
      value: HomepageModuleType.LIST,
      name: 'homepage_module.portal_type_table'
    }
  ];

  public ngOnInit(): void {
    if (this.link()) {
      const { id, name, type } = this.link();
      this.formGroup.patchValue({
        id,
        name,
        type
      });
    }
  }

  public save(): void {
    const { id, name, type } = this.formGroup.value as HomepageModule;
    this.closeModal({
      id,
      name,
      type
    });
  }
}
